import { ICartData, ICartItem, IUndoCartItem } from '../interfaces';
import { getSessionStorageItem, setSessionStorageItem } from '../../../../DAL/storage-provider';
import { ProductDepartmentEnum } from '../../../products/enums/product-department-enum';

// https://wavesaudio.atlassian.net/browse/DSWEB-1017
const STORAGE_KEY = 'skus-removed-from-cart';

// ----------------- STORAGE ---------------------

const getCartItemsFromStorage = () => {
    const saved = getSessionStorageItem(STORAGE_KEY);
    let parsed:IUndoCartItem[]|null = null;

    if(saved){
        try{
            parsed = JSON.parse(saved);
        }
        catch(ex){}
    }

    if(!parsed || !Array.isArray(parsed)){
        parsed = [];
    }

    return parsed;
};

const addToUndoCartItemStorage = (cartItem: ICartItem) => {

    const saved = getCartItemsFromStorage();

    const found = saved.find(item => item.skuid === cartItem.skuid);
    if(found) return;

    saved.push({
        skuid: cartItem.skuid,
        name: cartItem.skuName,
        quantity: cartItem.skuUnits,
    });

    setSessionStorageItem(STORAGE_KEY, saved);
};

const removeFromUndoCartItemStorage = (skuId: number) => {
    if(!skuId) return;

    const saved = getCartItemsFromStorage();

    const index = saved.findIndex(item => item.skuid === skuId);
    if(index === -1) return;

    saved.splice(index, 1);

    setSessionStorageItem(STORAGE_KEY, saved);
};

const checkIfCartItemCanUndo = (cartItem: ICartItem) => {

    // TODO:
    // if(cartItem.PDLOfferGUID) return false;

    const exclude = [
        ProductDepartmentEnum.Subscription,
        ProductDepartmentEnum.RentToOwnDynamic,
        ProductDepartmentEnum.RentToOwnStatic,
        ProductDepartmentEnum.WavesUpdatePlan,
        ProductDepartmentEnum.Upgrades,
        ProductDepartmentEnum.SubscriptionDynamic,
        ProductDepartmentEnum.Gifts,
        ProductDepartmentEnum.SampleMakerSubscriptions,
        ProductDepartmentEnum.VoiceRegenSubscriptions,
        ProductDepartmentEnum.MasteringSubscriptions,
    ];

    const found = exclude.find(departmentId => departmentId === cartItem.skuDepartmentID);
    return !found;
};

// ----------------- HELPERS ---------------------

/**
 * Get removed cart items from session storage.
 * Filter out the existing cart items.
 */
export const getUniqueRemovedCartItems = (cartData: ICartData) : IUndoCartItem[] => {
    const saved = getCartItemsFromStorage();
    if(!saved || !Array.isArray(saved) || saved.length <= 0) return [];

    const set = new Set();
    for(let cartItem of cartData.cartItems){
        set.add(cartItem.skuid);
    }

    const removed = [];
    for(let removedItem of saved){
        if(set.has(removedItem.skuid)){
            continue;
        }
        removed.push(removedItem);
    }

    setSessionStorageItem(STORAGE_KEY, removed);

    return removed;
};

/**
 * Move cart item from the cart products to the 'undo cart items list'.
 */
export const undoCartItem = (cartItem: ICartItem) => {

    if(!checkIfCartItemCanUndo(cartItem)){
        return getCartItemsFromStorage();
    }

    addToUndoCartItemStorage(cartItem);
    return getCartItemsFromStorage();
};

/**
 * Permanently delete saved cart item.
 */
export const removeUndoCartItem = (undoCartItem: IUndoCartItem) => {
    removeFromUndoCartItemStorage(undoCartItem.skuid);
    return getCartItemsFromStorage();
};
